var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18748 0.625H2.39581V2.52083H6.18748V0.625Z",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 1.3833H7.70417C7.80473 1.3833 7.90117 1.42325 7.97228 1.49436C8.04339 1.56546 8.08333 1.66191 8.08333 1.76247V9.72497C8.08333 9.82553 8.04339 9.92197 7.97228 9.99308C7.90117 10.0642 7.80473 10.1041 7.70417 10.1041H0.879167C0.778605 10.1041 0.682163 10.0642 0.611055 9.99308C0.539948 9.92197 0.5 9.82553 0.5 9.72497V1.76247C0.5 1.66191 0.539948 1.56546 0.611055 1.49436C0.682163 1.42325 0.778605 1.3833 0.879167 1.3833H2.39583",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77499 7.0708H5.80833",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77499 5.17505H5.80833",
    stroke: "#9AAEBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyClipboard);
export default __webpack_public_path__ + "static/media/greyClipboard.0081645c359484af484c690569cec9da.svg";
export { ForwardRef as ReactComponent };